{
  "close": "닫기"
}
